import { Box, Button, Container, Divider, Typography } from "@material-ui/core";
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  buttonContainer: {
    position: "absolute",
    bottom: "10px",
    left: "0",
    right: "0",
    display: "flex",
    justifyContent: "flex-end",
    padding: theme.spacing(0, 2),
  },
  okButton: {
    padding: theme.spacing(1, 5),
    backgroundColor: "#007bff",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#007bff",
    },
  },
}));
export default function NoChangeError({ setShowComponent }) {
  const classes = useStyles();
  const handleOk = () => {
    setShowComponent("AccessPermission");
    // console.log("Ok");
  };
  return (
    <Box style={{ marginTop: "8px" }}>
      <Typography style={{ fontSize: "16px", fontWeight: 500 }} gutterBottom>
        Error:
      </Typography>
      <Box
        style={{ marginTop: "8px", border: "2px solid red", padding: "10px" }}
      >
        <Typography style={{ fontSize: "14px", fontWeight: 500, color: "red" }}>
          Role duplication: You are creating a new role with same set of
          permissions as an exisiting role. Please change permission set for the
          new role or add new team members to the exisitng role.
        </Typography>
      </Box>
      <Box className={classes.buttonContainer}>
        <Button onClick={handleOk} className={classes.okButton}>
          Ok
        </Button>
      </Box>
    </Box>
  );
}
